module.exports = __webpack_public_path__ + "static/media/entranceMobile.cad713c7.jpg";